import React, { useRef, useState } from "react";
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { convertStringToArray } from "../../Utils/utils";
import SliderNavigation from "../SliderNavigation";
import { imageUrl } from "../../constants/constants";

const Csr = () => {
  const navigate = useNavigate();
  const { getText } = useLanguageTranslation();
  const slider = useRef();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: csrData = [],
    csrError,
    csrIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "CSR-activities",
    lang: languageType,
  });

  const transformedCsrData = csrData
    .map((item) => ({
      ...item,
      field_events_image: convertStringToArray(item.field_events_image),
      field_csr_activities_image: convertStringToArray(
        item.field_csr_activities_image,
      ),
    }))
    .map((item) => [
      ...item.field_csr_activities_image,
      ...item.field_events_image,
    ])
    .flat();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  const [isPlaying, setIsPlaying] = useState(true);

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  const play = () => {
    slider.current.slickPlay();
  };
  const pause = () => {
    slider.current.slickPause();
  };

  const handlePlayPause = () => {
    setIsPlaying((prev) => {
      if (prev) {
        pause();
      } else {
        play();
      }
      return !prev;
    });
  };

  if (csrIsLoading) {
    return <Loader />;
  }

  if (csrError) {
    return <div>Error loading CSR activities.</div>;
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-6 csr-activities-sec wow zoomIn">
        <div className="title-sec d-flex">
          <h2>{getText("CSR Activities", "सीएसर गतिविधियाँ")}</h2>

          {/* <SliderNavigation slider={slider} section={"CSR"} /> */}
          <div className="owl-nav mt-2">
            <div className="arrow">
              <button
                className="left"
                onClick={prev}
                aria-label={`Previous csr item`}
              >
                <i className="fa fa-angle-left"></i>
              </button>

              <button
                className="play-pause"
                onClick={handlePlayPause}
                aria-label={isPlaying ? `Pause csr item` : `Play csr item`}
              >
                <i className={`fa ${!isPlaying ? "fa-play" : "fa-pause"}`}></i>
              </button>

              <button
                className="right"
                onClick={next}
                aria-label={`Next csr item`}
              >
                <i className="fa fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="csr-activities-box">
          <Slider {...settings} ref={slider}>
            {transformedCsrData.map((item, index) => (
              <div className="card-sec" key={index}>
                <div className="img-sec">
                  <img alt={item.title} src={imageUrl + item?.file_path} />
                </div>
                <div className="desc-sec">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.title }}
                    ></div>
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/sustainable-development/csr");
          }}
          className="quick-btn"
          aria-label={"View all about CSR Activities"}
        >
          {getText("View All", "सभी देखें")}
        </a>
      </div>
    </>
  );
};

export default Csr;
